import Swal from "sweetalert2";
import i18n from "../i18n";
import { selectPartner } from "../store/partnerStore";
import store from "../store/rootStore";
import { isV2Enabled, V2_SCREEN_KEYS } from "../v2/registry";
import { showErrorDialog } from "../v2/components/ErrorDialogHost";
import { redirectToConnectionError } from "../v2/routerRef";

// Axios errors with no response never reached the server (network down,
// timeout) — only those belong on the full-screen /connection-error page.
const isNetworkFailure = (err) => Boolean(err?.isAxiosError && !err.response);

const swalDialog = (err) => {
  const t = (key) => i18n.t(key);
  const partner = selectPartner(store.getState());

  // V2: true network failures get the full-screen /connection-error; every
  // other error (a server response with Error !== 0, even with an empty
  // Message) gets the branded dialog instead of the legacy Swal popup.
  if (isV2Enabled(V2_SCREEN_KEYS.ERROR_POPUP, partner)) {
    if (
      isNetworkFailure(err) &&
      isV2Enabled(V2_SCREEN_KEYS.CONNECTION_ERROR, partner) &&
      redirectToConnectionError()
    ) {
      return;
    }
    if (showErrorDialog(err?.mess)) {
      return;
    }
  }

  Swal.fire({
    html: err?.mess
      ? `
  <div class='error-mess-wrapper'>
    <p class='error-mess-text'>${err?.mess}</p>
  </div>
`
      : `
  <div class='error-mess-wrapper'>
    <p class='error-mess-text'>${t("ERROR_OPS")}</p>
    <p class='error-mess-text'>${t("ERROR_SOMETHING_WENT_WRONG")}</p>
    <p class='error-mess-text'>${t("ERROR_WORKING_ON_IT")}</p>
  </div>
`,
    confirmButtonText: t("CONFIRM"),
    customClass: {
      popup: "p-0",
      confirmButton: "error-popup-btn-style",
      actions: "w-100-percents",
    },
    showConfirmButton: true,
    color: "#000",
    background: "#fff",
  });
};

export default swalDialog;
